import { PrivacyPolicy } from '../components/policy-modal';
import { Footer } from '../components/footer';
import { Camp67Header } from '../components/camp67-header/camp67-header';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Privacy Policy - camp67' },
    {
      name: 'description',
      content: 'View our Privacy policy.',
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: 'https://camp67.com/cancellation-and-refund',
    },
  ];
};

export default function PrivacyPolicyPage() {
  return (
    <>
      <div className="bg-yellow-50">
        <div className="m-auto w-full rounded-b-md border-dotted border-b-black border-b pb-7">
          <Camp67Header isLogoLight={false} isDarkGlowHidden={true} textColor="dark" />
        </div>
        <main className="w-full xl:px-72 lg:px-72 md:px-20 px-10 py-20">
          <section>
            <PrivacyPolicy />
          </section>
        </main>
      </div>
      <Footer isHome={false} />
    </>
  );
}
